// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1bWKE","itemTitle":"ClientEmergencyInfo_itemTitle__gkf0Q","itemText":"ClientEmergencyInfo_itemText__3KM_X"};